import { styled } from '@mui/material/styles';

// Unlike the sign-in error page, this renders inside the app shell, so it
// fills the content area rather than the viewport and inherits the app theme.
export const ContentWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  padding: theme.spacing(8, 2),
}));
